"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Todo = _interopRequireDefault(require("./Todo.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    mode: {
      type: Boolean,
      default: false
    },
    todos: {
      default: []
    }
  },
  components: {
    Todo: _Todo.default
  },
  data: function data() {
    return {
      visibility: 'all'
    };
  }
};
exports.default = _default;